import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {CustomersActions} from '../store';
import {CustomersSelectors} from '../store/selectors';

@Injectable()
export class CustomersLoadedGuard implements CanActivate {

  constructor(private store$: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.readCustomersDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  readCustomersDone(): Observable<boolean> {

    return this.store$.pipe(
      select(CustomersSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          const params = {
            'order[createdAt]': 'desc'
          };
          this.store$.dispatch(CustomersActions.ReadCustomers({page: 1, params}));
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
